var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* 隐藏遮罩 */\n#loading {\n\tdisplay: none\n}\n.module-error{\n\twidth: 932px;\n\tmargin: 80px auto 0;\n\tbackground-color: #fff;\n\tbox-shadow: 0 8px 16px 0 rgb(0 0 0 / 10%);\n\tpadding: 20px 30px 40px;\n}\n.dt-content{\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n}\n#ERROR_TIP{\n\tmargin-bottom: 32px;\n\tmargin-top: 20px;\n}\n\n.errorIcon {\n\tbackground-image: url(" + escape(require("../images/agencySuccess.png")) + ");\n\tbackground-size: 40px 40px;\n\twidth: 40px;\n\theight: 40px;\n\tmargin-top: 40px\n}\n\n.errorTitle {\n\tmargin-top: 16px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: #252b3a;\n\tline-height: 26px\n}\n\n.errorContent {\n\tmargin-top: 12px;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: #252b3a;\n\tmargin-left: 60px;\n\tmargin-right: 60px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./public/hws/css/notify.lazy.css
// module id = 213
// module chunks = 0